import { render } from "./TicTacToeBoard.vue?vue&type=template&id=807401ce&scoped=true"
import script from "./TicTacToeBoard.js?vue&type=script&lang=js"
export * from "./TicTacToeBoard.js?vue&type=script&lang=js"

import "./TicTacToeBoard.scss?vue&type=style&index=0&id=807401ce&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807401ce"]])

export default __exports__